// extracted by mini-css-extract-plugin
export default {"modifiers":"MMBN-SmallModifiers_modifiers__6vtLj"};